import styled from 'styled-components';
import { palette } from 'styled-theme';

export const SidebarContainer = styled.aside`
  position: fixed;
  top: 74px;
  left: 0;
  width: ${(props) => (props.isCollapsed ? '80px' : '256px')};
  height: calc(100vh - 64px);
  border-right: 1px solid ${palette('border', 1)};
  box-shadow: 4px 0 12px rgba(99, 102, 241, 0.15);

  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 50;
  transition: width 0.3s ease;
  overflow-x: hidden;
`;

export const NavList = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const NavItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px ${(props) => (props.isCollapsed ? '24px' : '36px')} 12px
    ${(props) => (props.isCollapsed ? '24px' : '36px')};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  ${(props) =>
    props.isActive &&
    `
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: ${palette('border', 1)};
    }
  `}

  &:hover {
    background-color: rgba(99, 102, 241, 0.05);
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;

export const NavLabel = styled.span`
  font-size: 0.875rem;
  font-weight: ${(props) => (props.isActive ? '500' : '400')};
  color: ${(props) => (props.isActive ? '#6366f1' : '#1f2937')};
  letter-spacing: 0.35px;
  line-height: 20px;
  opacity: ${(props) => (props.isCollapsed ? '0' : '1')};
  transition: opacity 0.2s ease;
  overflow: hidden;
`;

export const CollapseButton = styled.button`
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
  background-color: #6366f1;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 2px 8px rgba(99, 102, 241, 0.3);
  transition: all 0.2s ease;

  &:hover {
    background-color: #5558e3;
    transform: translateX(-50%) scale(1.05);
  }

  svg {
    width: 20px;
    height: 20px;
    color: white;
    transform: ${(props) => (props.isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.3s ease;
  }
`;
